<template>
    <ies-form-field :field="field">
        <v-autocomplete hide-details dense outlined
            v-model="viewValue"
            label="Category"
            :items="categoryOptions"
            autocomplete
        ></v-autocomplete>

        <input type="hidden" :name="field.fieldName" :value="field.value">
    </ies-form-field>
</template>

<script>
    /**
     * Allows the setting of a hotel additional fee category from a list of
     * options
     */
    export default {
        name: 'ies-fee-category',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                categoryOptions: [{text: "Government Tax", value: 1}, {text: "Service Charge", value: 2}, {text: "City/Tourist Tax", value: 3}, {text: "Cleaning Fee", value: 4}, {text: "Miscellaneous", value: 5}],
                viewValue: parseInt(this.field.value),
            }
        },

        methods: {
            updateField:function(){
                console.log(this.viewValue);
                this.getRelatedRecordType();
            }
        },

        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
console.log(this.field.value);
            }
        },
    }
</script>
